/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Edge } from "./Edge";
import { SourceField } from "./SourceField";
import { DestinationField } from "./DestinationField";
export const JobExecutionPlanConfig = core.serialization.object({
    fieldMapping: core.serialization.list(Edge).optional(),
    unmappedSourceFields: core.serialization.list(SourceField).optional(),
    unmappedDestinationFields: core.serialization.list(DestinationField).optional(),
    programId: core.serialization.string().optional(),
});
